<template>
  <div class="card-container">
    <common-top-form
      selectShowPower="/apppointsorderquery/select"
      :model="formModel"
      :submitService="submitService"
      :submitData="submitData"
      @success="onSuccess"
      :show="false"
      downloadPower="/apppointsorderquery/PeopleExport"
      :showDownloadPower="false"
      @down="down"
      showDownloadPowerType="warning"
    >
        <el-form-item label="终端类型">
            <el-select clearable v-model="formModel.acctType">
                <el-option
                    v-for="item in acctTypes"
                    :key="item.dictKey"
                    :label="item.dictValue"
                    :value="item.dictKey"
                >
                </el-option>
            </el-select>
        </el-form-item>
        <div class="flex-row vertical-center flow-wrap" v-show="isAcctype">
            <el-form-item label="用户ID">
                <el-input v-model="formModel.merchantNo" placeholder="请输入"></el-input>
            </el-form-item>

            <el-form-item label="用户手机号">
                <el-input v-model="formModel.agentPhone" placeholder="请输入"></el-input>
            </el-form-item>
        </div>
        <div class="flex-row vertical-center flow-wrap"  v-show="!isAcctype">
            <el-form-item label="商户号">
                <el-input
                    v-model="formModel.merchantNo"
                    placeholder="请输入"
                ></el-input>
            </el-form-item>
            <el-form-item label="商户手机号">
                <el-input v-model="formModel.agentPhone" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="商户名称">
                <el-input v-model="formModel.merName" placeholder="请输入"></el-input>
            </el-form-item>
        </div>
      <el-form-item label="订单号">
        <el-input
          v-model="formModel.orderNo"
          maxlength="50"
          placeholder="请输入"
        ></el-input>
      </el-form-item>
      <el-form-item label="订单状态">
        <el-select v-model="formModel.orderStatus">
          <el-option
            v-for="item in topStatus"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="支付方式">
        <el-select v-model="formModel.payTypeScope">
          <el-option
            v-for="item in payTypeScope"
            :key="item.dictKey"
            :label="item.dictValue"
            :value="item.dictKey"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="创建时间">
        <el-date-picker
          v-model="time"
          type="daterange"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="变更时间">
        <el-date-picker
          v-model="updateTime"
          type="daterange"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </el-form-item>
    </common-top-form>
    <common-table :data="tableData" ref="commonTable" @handleChange="getPage">
        <el-table-column
            prop="acctType"
            label="终端类型"
            :formatter="formatterTableAcctype"
            min-width="230"
            show-overflow-tooltip
        ></el-table-column>
      <el-table-column
        prop="merchantNo"
        :label="isAcctype ? '用户id' : '商户号'"
        min-width="220"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="merName"
        :label="isAcctype ? '用户名称' : '商户名称'"
        min-width="120"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="agentPhone"
        :label="isAcctype ? '用户手机号' : '商户手机号'"
        min-width="120"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="orderNo"
        label="订单号"
        min-width="350"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="status"
        label="订单状态"
        :formatter="formatterTableTrantype"
        min-width="120"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="payTypeScope"
        label="支付方式"
        min-width="120"
        :formatter="formatterTablepayTypeScope"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="dispatchType"
        label="配送方式"
        :formatter="formatterTableData"
        min-width="120"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="goodName"
        label="商品名称"
        :formatter="formatterTableData"
        min-width="220"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="orderAmt"
        label="积分"
        :formatter="formatterTableData"
        min-width="120"
        show-overflow-tooltip
      ></el-table-column>
      <!-- <el-table-column prop="payImgUrl" label="支付凭证" min-width="120">
        <template slot-scope="scope">
          <div
            class="iconUrl"
            @click="look(scope)"
            :style="
              'background:url(' +
              scope.row.payImgUrl +
              ') center/cover no-repeat'
            "
          ></div>
        </template>
      </el-table-column> -->
      <el-table-column
        prop="expressName"
        label="快递公司"
        :formatter="formatterTableExpressName"
        min-width="120"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="expressNo"
        label="快递编号"
        :formatter="formatterTableData"
        min-width="350"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="expressUpdateTime"
        label="快递更新时间"
        :formatter="formatterTableData"
        min-width="120"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="receiveName"
        label="收货人姓名"
        :formatter="formatterTableData"
        min-width="120"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="receivePhone"
        label="收货人手机号"
        :formatter="formatterTableData"
        min-width="120"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="receiveAddr"
        label="收货人地址"
        :formatter="formatterTableData"
        min-width="200"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="createTime"
        label="创建时间"
        min-width="180"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="updateTime"
        label="修改时间"
        min-width="180"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="remark"
        label="备注"
        min-width="200"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column label="操作" min-width="260" fixed="right">
        <template slot-scope="scope">
          <el-button
            type="text"
            v-if="scope.row.status == 6"
            @click="openAddDialog(1, scope.row)"
            >审核</el-button
          >
          <el-button type="text" @click="openAddDialog(2, scope.row)"
            >编辑</el-button
          >
          <span>
            <el-button
              type="text"
              @click="logisticsInfo(9, scope.row)"
              v-if="scope.row.status == 3 || scope.row.status == 2"
              >查看物流</el-button
            >
            <el-button type="text" v-else :disabled="true"
              >暂无物流信息</el-button
            >
          </span>
        </template>
      </el-table-column>
    </common-table>
    <form-dialog
      ref="formDialog"
      formDialogTitle="操作"
      :model="dialogModel"
      :submitData="dialogData"
      :dialogService="dialogService"
      @close="dialogClose"
      @success="dialogSuccess"
      labelWidth="110px"
      class="note"
      :rules="dialogRules"
    >
      <div v-if="type == 1">
        <!-- <div style="display: flex; justify-content: center"> -->
        <el-form-item label="审核" prop="checkStatus">
          <el-radio v-model="dialogModel.checkStatus" label="0">驳回</el-radio>
          <el-radio v-model="dialogModel.checkStatus" label="1">通过</el-radio>
        </el-form-item>
        <!-- </div> -->
        <el-form-item
          label="驳回原因"
          prop="reason"
          v-if="dialogModel.checkStatus == 0"
          style="margin-top: 20px"
        >
          <el-input
            v-model="dialogModel.reason"
            maxlength="180"
            show-word-limit
            type="textarea"
            resize="none"
            rows="5"
          ></el-input>
        </el-form-item>
      </div>
      <div v-if="type == 2">
        <el-form-item label="订单号" prop="orderNo">
          <el-input
            type="text"
            maxlength="20"
            v-model="dialogModel.orderNo"
            :disabled="true"
          ></el-input>
        </el-form-item>
        <el-form-item label="商户手机号" prop="agentPhone">
          <el-input
            type="text"
            maxlength="20"
            v-model="dialogModel.agentPhone"
            :disabled="true"
          ></el-input>
        </el-form-item>
        <el-form-item label="商户名称" prop="merName">
          <el-input
            type="text"
            maxlength="20"
            v-model="dialogModel.merName"
            :disabled="true"
          ></el-input>
        </el-form-item>
        <el-form-item label="订单状态" prop="status">
          <el-select v-model="dialogModel.status">
            <el-option
              v-for="item in topStatus.slice(1, topStatus.length)"
              :key="item.id"
              :label="item.name"
              :value="item.id - 0"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="快递公司" prop="expressName">
          <el-select v-model="dialogModel.expressName">
            <el-option
              v-for="item in ExpressTypes"
              :key="item.dictValue"
              :label="item.dictKey"
              :value="item.dictValue"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="快递单号" prop="expressNo">
          <el-input
            type="text"
            maxlength="100"
            v-model="dialogModel.expressNo"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item label="收货人姓名" prop="receiveName">
          <el-input
            type="text"
            maxlength="20"
            v-model="dialogModel.receiveName"
            placeholder="请输入收货人姓名"
          ></el-input>
        </el-form-item>
        <el-form-item label="收货人手机号" prop="receivePhone">
          <el-input
            type="text"
            maxlength="20"
            v-model="dialogModel.receivePhone"
            placeholder="请输入收货人手机号"
          ></el-input>
        </el-form-item>
        <el-form-item label="收货地址" prop="receiveAddr">
          <el-input
            type="text"
            maxlength="255"
            v-model="dialogModel.receiveAddr"
            placeholder="请输入收货地址"
          ></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input
            v-model="dialogModel.remark"
            maxlength="80"
            show-word-limit
            type="textarea"
            resize="none"
            rows="5"
          ></el-input>
        </el-form-item>
      </div>
    </form-dialog>
    <!-- <show-info-dialog
      title="支付凭证"
      :show="true"
      ref="showInfoDialog"
      class="showInfoDialog"
    >
      <div v-if="czimgUrl == '' || czimgUrl == null">
        <div
          style="
            display: flex;
            justify-content: center;
            color: red;
            font-size: 20px;
          "
        >
          暂未提供支付凭证,还请核实!!!
        </div>
      </div>
      <div v-else>
        <img
          class="showImage flex-row absolute-center"
          :src="czimgUrl"
          alt=""
          srcset=""
        />
      </div>
    </show-info-dialog> -->
  </div>
</template>

<script>
import CommonTopForm from "components/common/CommonTopForm";
import CommonTable from "components/common/CommonTable";
import FormDialog from "../../dialog/FormDialog";
import ShowInfoDialog from "../../dialog/ShowInfoDialog";

import ShopService from "service/ShopService";
import StatisticsService from "service/StatisticsService";

import TimeRange from "service/constant/TimeRange";
import { encrypt, urlEncode, objKeySort } from "common/js/common-utils";
import { loadMixin, dialogMixin, validatorsMixin } from "mixin";
import { mapGetters } from "vuex";

export default {
  name: "apppointsorderquery",
  components: {
    CommonTopForm,
    CommonTable,
    FormDialog,
    ShowInfoDialog,
  },
  data() {
    return {
      // czimgUrl: "",
      type: "",
      itemId: "",
      tatStatus: "",
      formModel: {
        merchantNo: "",
        merName: "",
        agentPhone: "",
        orderNo: "",
        orderStatus: "",
        payTypeScope: "",
          acctType: '7',
      },
      tableData: [],
      submitService: ShopService.apppointsorderqueryList,
      time: TimeRange.monthRange,
      updateTime: [],
      status: [],
      dialogRules: {},
      topStatus: [
        {
          id: "",
          name: "全部",
        },
      ],
      payTypeScope: [
        {
          dictKey: "",
          dictValue: "全部",
        },
      ],
      page: {},
      dialogModel: {
        merchantNo: "",
        merName: "",
        agentPhone: "",
        receiveAddr: "",
        receivePhone: "",
        status: "",
        remark: "",
        expressName: "",
        expressNo: "",
        receiveName: "",
        orderNo: "",

        checkStatus: "1",
        reason: "",
      },
      isPage: false,
      ExpressTypes: [],
        acctTypes: [{
            dictKey: "7",
            dictValue: "个人版",
        },
            {
                dictKey: "9",
                dictValue: "商户端",
            }]
    };
  },
  inject: ["reload"],
  mixins: [loadMixin, dialogMixin, validatorsMixin],
  mounted() {
    this.getTypeNames("快递公司", (res) => {
      this.ExpressTypes = res;
    });
    this.getTypeNames("merchantPayType", (res) => {
      this.payTypeScope = [...this.payTypeScope, ...res];
    });
    this.load();
  },
  computed: {
      isAcctype(){
          return this.formModel.acctType == '7'
      },
    submitData() {
      if (this.time == null || this.time == "") {
        this.time = [];
      }
      if (this.updateTime == null || this.updateTime == "") {
        this.updateTime = [];
      }
      this.params = {
        merchantNo: this.formModel.merchantNo,
          acctType: this.formModel.acctType,
        merName: this.formModel.merName.trim(),
        agentPhone: this.formModel.agentPhone.trim(),
        orderNo: this.formModel.orderNo.trim(),
        orderStatus: this.formModel.orderStatus,
        payTypeScope: this.formModel.payTypeScope,
        current: this.isPage ? this.page.currentPage : 1,
        size: this.page.pageSize,
      };
      if (this.time.length) {
        this.params.createTimeStart = this.time[0];
        this.params.createTimeEnd = this.time[1];
      }
      if (this.updateTime.length) {
        this.params.updateTimeStart = this.updateTime[0];
        this.params.updateTimeEnd = this.updateTime[1];
      }

      return this.params;
    },
    dialogData() {
      if (this.type == 1) {
        const params = {
          checkStatus: this.dialogModel.checkStatus,
          reason: this.dialogModel.reason,
        };
        if (this.itemId) {
          params.id = this.itemId;
        }
        return params;
      } else if (this.type == 2) {
        const params = {
          merName: this.dialogModel.merName,
          agentPhone: this.dialogModel.agentPhone,
          receiveAddr: this.dialogModel.receiveAddr,
          receivePhone: this.dialogModel.receivePhone,
          status: this.dialogModel.status,
          remark: this.dialogModel.remark,
          expressName: this.dialogModel.expressName,
          expressNo: this.dialogModel.expressNo,
          receiveName: this.dialogModel.receiveName,
          orderNo: this.dialogModel.orderNo,
        };
        if (this.itemId) {
          params.id = this.itemId;
        }
        return params;
      }
    },
    dialogService() {
      return this.type == 2
        ? ShopService.apppointsorderqueryEdit
        : ShopService.apppointsorderqueryShenHe;
    },
    ...mapGetters(["serverType", "tatId", "userId", "orgDetail"]),
  },
  watch: {
      'formModel.acctType'(){
          this.formModel.merchantNo = '';
          this.formModel.agentPhone = '';
          this.formModel.merName = '';
      },
  },
  methods: {
    load() {
      this.formModel = {
        merName: "",
        agentPhone: "",
        orderNo: "",
        orderStatus: "",
        payTypeScope: "",
          acctType: '7',
      };
      this.page = this.$refs.commonTable.page;
      this.gettopStatus();
      this.getList();
    },
    getPage() {
      this.isPage = true;
      this.getList();
    },
    getList() {
      this.doLoad(
        this.submitService,
        this.submitData,
        (res) => {
          this.doCheck(res, (res) => {
            this.onSuccess(res);
            this.isPage = false;
          });
        },
        "信息获取失败"
      );
    },
    onSuccess(res) {
      this.doCheck(res, (res) => {
        const result = res.contents;
        this.tableData = result.rows;
        this.page.currentPage = result.current;
        this.page.total = result.total;
        this.page.pageSize = result.size;
      });
    },
    openAddDialog(type, item) {
      this.type = type;
      this.itemId = item ? item.id : "";
      if (type == 2) {
        this.dialogModel = JSON.parse(JSON.stringify(item));
        this.dialogModel.remark = this.dialogModel.remark
          ? this.dialogModel.remark
          : "";
      }
      this.$refs.formDialog.open();
    },
    dialogSuccess(res) {
      this.showSuccess(res.respMsg);
      this.$refs.formDialog.closeDialog();
      this.getList();
    },
    dialogClose() {
      this.dialogModel = {
        merName: "",
        agentPhone: "",
        receiveAddr: "",
        receivePhone: "",
        status: "",
        remark: "",
        expressName: "",
        expressNo: "",
        receiveName: "",
        orderNo: "",

        checkStatus: "1",
        reason: "",
      };
      this.type = "";
      this.itemId = "";
    },
    // 查看物流信息
    logisticsInfo(flag, item) {
      this.$router.push({
        name: "logisticsinfo",
        params: {
          logisticsinfoinfo: JSON.stringify(item),
          flag: flag,
        },
      });
    },
    down() {
      this.limitExport(this.page.total)
        ? StatisticsService.exportExcel(
            this.submitData,
            "tatPublicPlatoonPeopleExport",
            "8880",
            "/tatPublicPlatoonPeople/"
          )
        : "";
    },
    gettopStatus() {
      this.doLoad(
        ShopService.topStatus,
        "",
        (res) => {
          this.doCheck(res, (res) => {
            this.topStatus = [...this.topStatus, ...res.contents];
          });
        },
        "信息获取失败"
      );
    },
    // look(scope) {
    //   this.czimgUrl = scope.row.payImgUrl;
    //   this.$refs.showInfoDialog.open();
    // },
    formatterTableTrantype(row, column, cellValue, index) {
      let value = "";
      this.topStatus.forEach((item) => {
        if (item.id == cellValue) {
          value = item.name;
        }
      });

      return value ? value : "--";
    },
    formatterTableExpressName(row, column, cellValue, index) {
      let value = "";
      this.ExpressTypes.forEach((item) => {
        if (item.dictValue == cellValue) {
          value = item.dictKey;
        }
      });

      return value ? value : "--";
    },
    formatterTablepayTypeScope(row, column, cellValue, index) {
      let value = "--";
      this.payTypeScope.forEach((item) => {
        if (item.dictKey == cellValue) {
          value = item.dictValue;
        }
      });
      return value;
    },
      formatterTableAcctype(row, column, cellValue, index) {
          let value = "--";
          this.acctTypes.forEach((item) => {
              if (item.dictKey == cellValue) {
                  value = item.dictValue;
              }
          });
          return value;
      },
  },
};
</script>

<style scoped>
.iconUrl {
  width: 50px;
  height: 50px;
  margin: auto;
  overflow: hidden;
}

.showImage {
  max-width: 100%;
  min-width: 738px;
  min-height: 500px;
  object-fit: contain;
}
</style>



// WEBPACK FOOTER //
// src/view/page/AppManager/AppPointsOrderQuery.vue